import { Card, DateInput, Input, Label, Select } from "components";
import { useDepartement, useJobPosition, useMainLocation } from "../../../CreateNewEmployee/components/FormSection/utils";
import { debounce } from "lodash";
import moment from "moment";
import { useFormContext, useWatch } from "react-hook-form";
import { FormType } from "../../schemas";
import { useFilterStore } from "../../stores";

export function Filter() {

    // hooks
    const { dataDepartement, isLoadingDepartement } = useDepartement()
    const { dataJobPosition, isLoadingJobPosition } = useJobPosition()
    const { dataMainLocation, isLoadingMainLocation } = useMainLocation()

    //  state
    const { filter, setFilter } = useFilterStore();
    const onDebounce = debounce((e: any) => {
        setFilter({ keyword: e.target.value });
    }, 300);

    // form
    const { control } = useFormContext<FormType>()

    const codeForm = useWatch({
        control,
        name: "code"
    })


    return (
        <Card>
            <Card.Body>
                <div className="lg:flex lg:justify-between lg:items-end">
                    <div className="flex gap-2 mb-3 items-center">
                        <div>
                            <Input
                                label="SEARCH"
                                className="lg:w-[300px] md:w-full"
                                placeholder="Search data..."
                                onChange={onDebounce}
                            />
                        </div>
                    </div>
                    <div className="flex lg:items-end mb-4 lg:flex-row flex-col lg:justify-between gap-1">
                        <Select
                            label="DEPARTMENT"
                            placeholder="Select department"
                            className="lg:w-[200px] md:w-full me-2"
                            width={true}
                            isLoading={isLoadingDepartement}
                            options={[{ label: "ALL", value: "" }, ...dataDepartement]}
                            value={dataDepartement.find(
                                (item) => item.value === filter?.department) ??
                                { label: "ALL", value: "" }}
                            onChange={(e) =>
                                setFilter({ ...filter, department: e?.value ?? "" })
                            }
                        />
                        <Select
                            label="JOB POSITION"
                            placeholder="Select job position"
                            className="lg:w-[200px] md:w-full me-2"
                            width={true}
                            isLoading={isLoadingJobPosition}
                            options={[{ label: "ALL", value: "" }, ...dataJobPosition]}
                            value={
                                dataJobPosition.find((item) => item.value === filter?.jobpos) ??
                                { label: "ALL", value: "" }
                            }
                            onChange={(e) =>
                                setFilter({ ...filter, jobpos: e?.value ?? "" })
                            }
                        />
                        <Select
                            label="MAIN LOCATION"
                            placeholder="Select main location"
                            className="lg:w-[200px] md:w-full me-2"
                            width={true}
                            isLoading={isLoadingMainLocation}
                            options={[{ label: "ALL", value: "" }, ...dataMainLocation]}
                            value={dataMainLocation.find(
                                (item) => item.value === filter?.location) ??
                                { label: "ALL", value: "" }}
                            onChange={(e) =>
                                setFilter({ ...filter, location: e?.value ?? "" })
                            }
                        />
                    </div>
                </div>

                <div className="flex lg:justify-between lg:flex-row flex-col lg:items-center gap-2">
                    <div className="flex lg:flex-row flex-col gap-2 lg:items-center">
                        <Label>PERIODE</Label>
                        <div>
                            <DateInput
                                selected={
                                    filter.date_start
                                        ? moment(filter.date_start).toDate()
                                        : null
                                }
                                onChange={(date) =>
                                    setFilter({
                                        ...filter,
                                        date_start: date ? moment(date).format("YYYY-MM-DD") : "",
                                    })
                                }
                            />

                        </div>
                        <div>
                            <DateInput
                                selected={
                                    filter.date_end
                                        ? moment(filter.date_end).toDate()
                                        : null
                                }
                                onChange={(date) =>
                                    setFilter({
                                        ...filter,
                                        date_end: date ? moment(date).format("YYYY-MM-DD") : "",
                                    })
                                }
                                minDate={
                                    filter.date_start
                                        ? moment(filter.date_start).toDate()
                                        : undefined
                                }
                                maxDate={
                                    filter.date_end
                                        ? moment(filter.date_end).add(30, "days").toDate()
                                        : undefined
                                }
                            />

                        </div>
                    </div>

                    <div className="flex lg:flex-row flex-col gap-2 lg:items-center">
                        <Label>ID SCHEDULE</Label>
                        <div>
                            <Input
                                placeholder="ID SCHEDULE"
                                value={codeForm}
                            />
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}